/** 校验规则是否超过三个 */
export const rulesExceedThreeBoolFun = (val) => {
  const validBoolArr = [];
  const attnameArr = ["hasUppercase", "hasLowercase", "hasNumber", "hasOther"];

  for (const name of attnameArr) {
    validBoolArr.push(passwordValid[name](val));
  }

  const validTrueArrLen = validBoolArr.filter((item) => item).length;
  return validTrueArrLen >= 3;
};

/** 密码正则 大于八位，大小写字母、数字、特殊符号（`~!@#$%^&*()-_= |;:'",.<>?）*/
export const passwordValid = {
  valLen: (val) => {
    return /(?=.{8})/g.test(val);
  },
  // 有大写字母
  hasUppercase: (val) => {
    return /(?=.*?[A-Z])/g.test(val);
  },
  // 有小写字母
  hasLowercase: (val) => {
    return /(?=.*?[a-z])/g.test(val);
  },
  // 有数字
  hasNumber: (val) => {
    return /(?=.*?\d)/g.test(val);
  },
  // 有特殊字符
  hasOther: (val) => {
    return /(?=.*[^a-zA-Z0-9])/g.test(val);
  },
  // 不包含的特殊字符
  noHasCharacters: (val) => {
    const value = val.replace(/[a-zA-Z0-9]/g, "");
    return !/([^`~!@#$%^&*()\-_=\\|;:'",.<>?])/g.test(value);
  },
  // 不包含的特殊字符
  deletSpecial: (val) => {
    return val.replace(/[a-z0-9A-Z`~!@#$%^&*()\-_=\\|;:'",.<>?]/g, "");
  },
};

/** 校验密码 */
export const validatePasswordUtils = (rule, value, callback) => {
  let bool = true;

  let rulesExceedThreeBool = true;
  if (value && passwordValid.valLen(value)) {
    rulesExceedThreeBool = rulesExceedThreeBoolFun(value);
  }

  if (value === "") {
    callback(new Error("请输入密码"));
    bool = false;
  } else if (!passwordValid.valLen(value)) {
    callback(new Error("密码长度过短"));
    bool = false;
  } else if (!rulesExceedThreeBool) {
    callback(new Error("密码需至少包含3类字符（大写字母、小写字母、数字、特殊符号）"));
    bool = false;
  } else if (!passwordValid.noHasCharacters(value)) {
    const showStr = passwordValid.deletSpecial(value);
    callback(new Error(`不支持使用${showStr.replace(/\s+/g, "")}${/\s+/g.test(showStr) ? "空格" : ""}作为密码`));
    bool = false;
  }

  return bool;
};

/** 特殊字符字符串展示 */
export const specialSymbolsStr = new String("(`~!@#$%^&*()-_=|;:'") + new String('",.<>?)');
